<template>
    <div class="container">
        <vue-simple-spinner v-if="loading" />
        <form id="enrollment-form" @submit="checkForm" class="ui form segment" v-if='!loading && !error' novalidate="true">
            <img class="ui image" :src="image" />
            <h1>{{ programTitle }}</h1>
            <p v-html="instructions"></p>
            <p v-if="errors.length" class="error">
                <b>Please correct the following error(s):</b>
                <ul>
                    <li v-for="error in errors" v-bind:key="error">{{ error }}</li>
                </ul>
            </p>
            <p class="field">
                <label for="firstName">First Name<span class="asterisk">*</span></label>
                <input
                id="firstName"
                v-model="firstName"
                type="text"
                name="firstName"
                >
            </p>
            <p class="field">
                <label for="lastName">Last Name<span class="asterisk">*</span></label>
                <input
                id="lastName"
                v-model="lastName"
                type="text"
                name="lastName"
                >
            </p>
            <p class="field">
                <label for="emailAddress">Email Address<span class="asterisk">*</span></label>
                <input
                id="emailAddress"
                v-model="emailAddress"
                type="email"
                name="emailAddress"
                
                >
            </p>
            <input type="hidden" name="auth" :value="registrationKey" />
            <p>
                <input
                type="submit"
                value="Sign Up!"
                class="ui button primary"
                id="submitButton"
                >
            </p>
        </form>
        <div class="ui segment" v-if="!loading && error">
            <img class="ui image" src="https://s3.amazonaws.com/booster.data/booster-images/bl_logo_new.gif" />
            <div class="ui errorMessage">
                {{ error }}
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'SelfEnrollment',
    props: [ 'api', 'registrationKey' ],
    data() {
        return {
            loading: true,
            firstName: '',
            lastName: '',
            emailAddress: '',
            errors: [],
            error: null,
            image: '',
            programTitle: '',
            instructions: ''
        }
    },
    methods: {
        checkForm: function(event) {
            event.preventDefault()
            this.errors = [];

            if (!this.firstName) {
                this.errors.push('First Name required.');
            }
            if (!this.lastName) {
                this.errors.push('Last Name required.');
            }
            
            if (!this.emailAddress) {
                this.errors.push('Email Address required.');
            } else if (!this.validEmail(this.emailAddress)) {
                this.errors.push('Valid Email Address required.')
            }
            if (this.errors.length > 0) {
                return false;
            }
            let _this = this
            this.api.post('/api/enroll',
            {
                first: this.firstName,
                last: this.lastName,
                email: this.emailAddress,
                key: this.registrationKey
            }).then(result => {

                 _this.$router.push({ name: 'register-result', params: {  registrationkey: this.registrationKey, success: result.data.success, error: result.data.error, message: result.data.message }}); return result 
                 }).catch(err => err);
            
            
        },
        validEmail: function (email) {
            var at = email.indexOf( "@" );
            var dot = email.lastIndexOf( "." );
            return email.length > 0 &&
                at > 0 &&
                dot > at + 1 &&
                dot < email.length &&
                email[at + 1] !== "." &&
                email.indexOf( " " ) === -1 &&
                email.indexOf( ".." ) === -1;
        },
        fetchData: async function() {
            this.error = this.post = null
            this.loading = true

            let response = await this.api.get('/api/content',
            {
                params: {
                    p: this.$route.path
                }
            }).catch(err => err);

            this.loading = false

            if (response instanceof Error) {
                this.error = response.response.data.error
            }
            else if(response.data.error) {
                this.error = response.data.error;
            }
            else {
                
                this.image = response.data.banner;
                this.instructions = response.data.instructions;
                this.programTitle = response.data.programTitle;
            }
        }
    },
    mounted() {
        this.fetchData()
    }
}
</script>
<style scoped>
.container {
    max-width: 640px;
    margin: 0 auto;
    text-align: left;
}
.ui.image {
    margin: 0 auto;
}
h1 {
    text-align: left;
    margin-bottom: 30px;
}
form {
    padding: 15px;
}
input {
    margin: 5px;
}
.asterisk {
    color: #F00;
    font-size: 20px;
    margin-left: 5px;
}
.error {
    color:  #F00;
}
.errorMessage {
    padding: 15px;
}
</style>